import { autoinject } from 'aurelia-framework';
import { EventAggregator } from 'aurelia-event-aggregator';
import { DialogController } from 'aurelia-dialog';

@autoinject
export class RegionsDialog {
    constructor(
        private _eventBus: EventAggregator,
        public controller: DialogController
    ) { }

    attached() {
        this._eventBus.subscribe('region-changed', e => {
            this.controller.ok();
        });
    }
}